import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const SettingsNew: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 40, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.25" y="0.25" width="39.5" height="39.5" rx="19.75" fill="white" stroke="#D8D8D6" strokeWidth="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5178 14.3154C10 15.2906 10 16.5672 10 19.1204V20.2001C10 21.7403 10 22.5103 10.1919 23.1385C10.6471 24.6285 11.861 25.7936 13.4134 26.2305C14.068 26.4147 14.8703 26.4147 16.475 26.4147H16.9964L17.0582 26.4148C18.0274 26.4207 18.9716 26.7111 19.7639 27.2469L19.8143 27.2814L22.2944 28.9817C23.1447 29.5645 24.2619 28.7227 23.8739 27.7917C23.599 27.1321 24.1051 26.4147 24.8453 26.4147H25.4169C27.3958 26.4147 29 24.875 29 22.9757V19.1204C29 16.5672 29 15.2906 28.4823 14.3154C28.0269 13.4576 27.3002 12.7601 26.4065 12.3231C25.3904 11.8262 24.0602 11.8262 21.4 11.8262H17.6C14.9397 11.8262 13.6096 11.8262 12.5935 12.3231C11.6997 12.7601 10.9731 13.4576 10.5178 14.3154ZM23.3 16.613C23.6935 16.613 24.0125 16.9192 24.0125 17.2969C24.0125 17.6745 23.6935 17.9807 23.3 17.9807H19.5C19.1065 17.9807 18.7875 17.6745 18.7875 17.2969C18.7875 16.9192 19.1065 16.613 19.5 16.613H23.3ZM23.3 20.2601C23.6935 20.2601 24.0125 20.5663 24.0125 20.944C24.0125 21.3216 23.6935 21.6278 23.3 21.6278H15.7C15.3065 21.6278 14.9875 21.3216 14.9875 20.944C14.9875 20.5663 15.3065 20.2601 15.7 20.2601H23.3Z"
        fill="#1B3029"
      />
    </svg>
  )
})

SettingsNew.displayName = 'SettingsNew'
